import { render, staticRenderFns } from "./WelcomeContentContainer.vue?vue&type=template&id=138dd238&scoped=true&"
import script from "./WelcomeContentContainer.vue?vue&type=script&lang=js&"
export * from "./WelcomeContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeContentContainer.vue?vue&type=style&index=0&id=138dd238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138dd238",
  null
  
)

export default component.exports